<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pviii"></a><a class="page" id="pix"></a>Contents</h1>
<p class="toc"><a class="xref" href="#/chiKing0008#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chiKing0009#ch01">1.  Insects and Arachnids</a></p>
<p class="toc"><a class="xref" href="#/chiKing0010#ch02">2.  Octopus</a></p>
<p class="toc"><a class="xref" href="#/chiKing0011#ch03">3.  Fish</a></p>
<p class="toc"><a class="xref" href="#/chiKing0012#ch04">4.  Chickens</a></p>
<p class="toc"><a class="xref" href="#/chiKing0013#ch05">5.  Goats</a></p>
<p class="toc"><a class="xref" href="#/chiKing0014#ch06">6.  Cows</a></p>
<p class="toc"><a class="xref" href="#/chiKing0015#ch07">7.  Pigs</a></p>
<p class="toc"><a class="xref" href="#/chiKing0016#ch08">8.  Chimpanzees</a></p>
<p class="toc"><a class="xref" href="#/chiKing0017#aft">Afterword</a></p>
<p class="tocbmf"><a class="xref" href="#/chiKing0018#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chiKing0019#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chiKing0020#index">Index</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-King-0007.vue?24a7a8cc